import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http } from "../lib/api";
import { AuthDialog } from "../components/AuthDialog";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState({ flight_source: "sample", payment_mode: "demo", assured_price: 399 });

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    http.get("/config").then((r) => setConfig(r.data)).catch(() => {});
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    await http.post("/auth/logout").catch(() => {});
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, logout, config }}>
      {children}
      <AuthDialog onAuthed={setUser} />
    </AuthCtx.Provider>
  );
};

export const AuthCallback = () => {
  const done = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    http
      .post("/auth/session", { session_id: sid })
      .then(({ data }) => setUser(data))
      .catch(() => setUser(null))
      .finally(() => navigate(location.pathname + location.search, { replace: true }));
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center" data-testid="auth-callback">
      <div className="h-10 w-10 rounded-full border-4 border-[#EC5B24] border-t-transparent animate-spin" />
    </div>
  );
};
